import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent {
  activeModal: string | null = null;

  openModal(projectId: string) {
    //this.activeModal = projectId;
  }

  closeModal() {
    this.activeModal = null;
  }

  // Detecta la tecla Esc y cierra el modal
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeModal();
  }
}